import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Unsubscribe";
const server = null;
const service = null;

const config = {
  details: {
    project,
    server,
    environment,
    service
  },
  application: {
    offer: {
      api: {
        endpoints: false
      },
      objects: {
        cmscode: {
          name: "cmscode",
          initial: "",
          label: "CMS CODE (AUTO GENERATED)",
          helperText: false,
          rules: ["isNotNull"]
        },
        title: {
          name: "title",
          initial: "",
          label: "Title",
          helperText: false,
          rules: ["isNotNull"]
        },
        description: {
          name: "description",
          initial: "",
          label: "Description",
          helperText: false,
          rules: ["isNotNull"],
          multiline: true,
          rows: 4
        },
        type: {
          name: "type",
          initial: "",
          label: "type",
          helperText: false,
          rules: ["isNotNull"]
        },
        startdate: {
          name: "startdate",
          initial: "",
          label: "Start Date",
          helperText: false,
          rules: ["isNotNull"]
        },
        enddate: {
          name: "enddate",
          initial: "",
          label: "End Date",
          helperText: false,
          rules: ["isNotNull"]
        },
        imagelarge: {
          name: "imagelarge",
          initial: "",
          label: "Image Large",
          placeholder: "https://",
          helperText: false,
          rules: ["isNotNull"]
        },
        imagemedium: {
          name: "imagemedium",
          initial: "",
          label: "Image Medium",
          placeholder: "https://",
          helperText: false,
          rules: ["isNotNull"]
        },
        imagesmall: {
          name: "imagesmall",
          initial: "",
          label: "Image Small",
          placeholder: "https://",
          helperText: false,
          rules: ["isNotNull"]
        },
        groupid: {
          name: "groupid",
          initial: "",
          label: "Group ID",
          helperText: false,
          rules: ["isNotNull"]
        },
        channel: {
          name: "channel",
          initial: "",
          label: "Channel",
          helperText: false,
          rules: ["isNotNull"]
        }
      }
    }
  },
  routes: {
    label: "Unsubscribe",
    prefix: "/u/:modulecode/:token"
  },
  setup
};

export default config;
